import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { spawnEmojiInFrontOfUser, emojis as emojiDataArray } from "../../components/emoji";
import { ToolbarEmojisButton } from "./FluentToolbarEmojisButton";
import { useToolbarContext } from "../contexts/ToolbarContext";
import { throttle } from "../../utils/throttle";
import { emitParticipantLayoutReaction } from "./participant-layout/participant-layout-reactions";
import { createToolbarEmojiSelectHandler } from "./toolbar-emojis-selection";

const EMOJI_SPAWN_COOLDOWN = 1000;

export default function ToolbarEmojisContainer({ styles, participantLayoutReactionTargetId }) {
  const { emojisOpen, onEmojisOpenChange } = useToolbarContext();
  const selectEmoji = useMemo(
    () =>
      createToolbarEmojiSelectHandler({
        participantLayoutReactionTargetId,
        spawnEmoji: spawnEmojiInFrontOfUser,
        emitReaction: emitParticipantLayoutReaction
      }),
    [participantLayoutReactionTargetId]
  );
  const throttledSelectEmoji = useMemo(() => throttle(selectEmoji, EMOJI_SPAWN_COOLDOWN), [selectEmoji]);

  const items = emojiDataArray.map(emoji => ({
    ...emoji,
    onSelect: throttledSelectEmoji
  }));

  return <ToolbarEmojisButton items={items} styles={styles} open={emojisOpen} onOpenChange={onEmojisOpenChange} />;
}

ToolbarEmojisContainer.propTypes = {
  participantLayoutReactionTargetId: PropTypes.string,
  styles: PropTypes.object
};
